import { Backdrop, Card } from '@material-ui/core';
import _ from 'lodash';
import React from 'react';

import Modal from '@/src/components/common/Elements/Modal/Modal';
import { cn } from '@/src/util/ui';

import { useGetLibraryItemDetails } from './components/Modal/FileViewer2/api/getLibraryItemDetails';
import { FileEntryViewer } from './components/Modal/FileViewer2/FileEntryViewer';
import { useInfoPanelQueries } from './components/Modal/FileViewer2/useInfoPanelQueries';

import Spinner from '../../common/Elements/Spinner/Spinner';
import ModalPortal from '../../common/Modal/ModalPortal';
import { FileEntryViewerInfoPanelProvider } from '../Inbox2/components/EntryPanel/FileEntryViewer/store/fileEntryViewer.infoPanel.store';
import { FileEntryViewerProvider } from '../Inbox2/components/EntryPanel/FileEntryViewer/store/fileEntryViewer.store';
import { InboxProvider } from '../Inbox2/store/inbox.store';

type FileEntryViewerPageProps = {
  libraryItemId: number;
  sourceId: number;
};

export const FileEntryViewerPage = ({ libraryItemId, sourceId }: FileEntryViewerPageProps) => {
  const libraryItemDetailsQuery = useGetLibraryItemDetails({
    libraryItemId,
  });
  const fileEntry = libraryItemDetailsQuery.data?.data;

  const infoPanelQueries = useInfoPanelQueries({
    libraryItemId: libraryItemId,
    sourceId: libraryItemId,
  });

  if (!fileEntry) {
    return <Spinner />;
  }

  const file = {
    id: libraryItemId,
    'source-id': sourceId,
    type: 'document',
    version: fileEntry.version,
  };

  return (
    <InboxProvider isTreatmentHidden={true}>
      <FileEntryViewerInfoPanelProvider infoPanelQueries={infoPanelQueries}>
        <FileEntryViewerProvider>
          <ModalPortal>
            <Modal id={'library-fileviewer'} className={cn('!tw-z-10')}>
              <Backdrop open={true}>
                <Card
                  className={cn(
                    'modal-dialog',
                    'tw-w-full  tw-mx-auto test class',
                    'tw-h-screen t'
                  )}
                  tabIndex={0}
                  onClick={(e) => e.stopPropagation()}
                  style={{ background: 'none' }}
                >
                  <div className="tw-flex tw-items-stretch tw-h-full">
                    <FileEntryViewer file={file} fileEntry={fileEntry} />
                  </div>
                </Card>
              </Backdrop>
            </Modal>
          </ModalPortal>
        </FileEntryViewerProvider>
      </FileEntryViewerInfoPanelProvider>
    </InboxProvider>
  );
};
